export const facetValueStates: FacetValueState[] = ['idle', 'selected'];
export type FacetValueState = 'idle' | 'selected';
